import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import {getAvailableColumns} from "./api";

export const path = '/signing-acts';

const PageActsOnSigning: React.FC = (props) => {
    const loader = {
        page: () => import('./page'),
        columns: getAvailableColumns
    };

    const ActsOnSigning = Loadable.Map({
        loader,
        loading: LoadableLoading,
        render(loaded, loadedProps) {
            const Page = loaded.page.default;

            return (
                <Page
                    {...loadedProps}
                    {...props}
                    columns={loaded.columns}
                />
            )
        }
    });

    return <ActsOnSigning />;
};

export default PageActsOnSigning;
